import React, { useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from "react-redux";
import { Checkbox, Form } from "antd";
import Card from '../../components/Card';
import Switcher from '../../components/Switcher';
import SystemFeeSetting from '../../components/SystemFeeSetting';
import SystemFeeReplenishmentSetting from '../../components/SystemFeeReplenishmentSetting';
import WithdrawalSetting from '../../components/WithdrawalSetting';
import { ButtonPrimary, ButtonSecondary } from '../../components/Button';
import {
  getAdminSettings,
  updateAdminSettings,
  getRolesList,
  createNewRole ,
  deleteRole,
  getRolePermissions,
  changeRolePermissions,
  getAgentFeesData,
  updateAgentFeesData
} from '../../../redux/actions/adminPanel/adminSettings';
import {scrollContainerIntoView} from "../../helpers/scrollIntoView";
import './style.scss';
import SystemRefund from '../../components/SystemRefund/SystemRefund';
import SystemFeeSwap from '../../components/SystemFeeSwap/SystemFeeSwap';
import SettingsToggler from "../../components/RoleSettings/SettingsToggler";
import { useTranslation } from "react-i18next";
import Button from "../../../components/Button";
import { ReactComponent as EditIcon } from "../../../img/adminPanel/edit.svg";
import { ReactComponent as RemoveIcon } from "../../../img/adminPanel/remove.svg";
import { ReactComponent as EditIconAdmin } from "../../../img/adminPanel/editAdmin.svg";
import { ReactComponent as RemoveIconAdmin } from "../../../img/adminPanel/removeAdmin.svg";
import { ReactComponent as LinkIcon } from "../../../img/default-svg/linkAdmin.svg";
import AddRoleModal from "../../components/RoleSettings/AddRoleModal";
import AddUserModal from "../../components/RoleSettings/AddUserModal";
import RemoveRoleModal from "../../components/RoleSettings/RemoveRoleModal";
import { getAdminUsers, updateAdminUser } from "../../../redux/actions/adminPanel/adminUsers";
import SystemFeeClientsReplenishment from "../../components/SystemFeeClientsReplenishment";
import { identity } from "../../../utils/getIdentity";

const Settings = ({
  adminSettingsData,
  adminSettingsFetching,
  getAdminSettings,
  updateAdminSettings,
  getRolesList,
  rolesList ,
  createNewRole,
  deleteRole,
  getRolePermissions,
  permissionsList,
  permissions,
  roleName,
  changeRolePermissions,
  getAdminUsers,
  usersList,
  usersCurrentPage,
  usersPages,
  updateAdminUser,
  getAgentFeesData,
  agentData,
  updateAgentFeesData
}) => {
  const [form] = Form.useForm();
  const adminSettingsRef = useRef();
  const [roleMode, setRoleMode] = useState('fee');
  const [isOpenAddRole, setIsOpenAddRole] = useState(false);
  const [isOpenAddUser, setIsOpenAddUser] = useState(false);
  const [removeId, setRemoveId] = useState('');
  const [removeName, setRemoveName] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [permissionId, setPermissionId] = useState('');
  const [isOpenRemoveRole, setIsOpenRemoveRole] = useState(false);
  const [currentPermissions, setCurrentPermissions] = useState([]);
  const [agentFees, setAgentFees] = useState({});
  const [initialData, setInitialData] = useState({});
  const { t } = useTranslation();

  const handleCheckboxChange = (name, field) => {
    setCurrentPermissions(prevPermissions =>
      prevPermissions.map(permission =>
        permission.name === name
          ? { ...permission, [field]: !permission[field] }
          : permission
      )
    );
  };

  const handleSubmit = () => {
    const newPermissions = currentPermissions.reduce((acc, { name, edit, view }) => {
      acc[name] = { edit, view };
      return acc;
    }, {});

    changeRolePermissions(permissionId, newPermissions);
    setEditMode(false);

    setTimeout(() => {
      getRolesList();
      getRolePermissions('edit', permissionId);
    }, 1000);

    setTimeout(() => {
      setPermissionId('');
    }, 1300);
  }

  const closeRemoveModal = () => {
    setRemoveId('');
    setRemoveName('');
    setIsOpenRemoveRole(false);
  };

  const editPermissions = (id) => {
    getRolePermissions('edit', id);
    setPermissionId(id);
    setEditMode(true);
  };

  const openRemoveModal = (id, name) => {
    setRemoveId(id);
    setRemoveName(name);
    setIsOpenRemoveRole(true);
  };

  const goBack = () => {
    if (roleMode === 'fee') {
      form.resetFields()
    } else {
      setEditMode(false);
    }
  }

  useEffect(() => {
    if (permissionsList) {
      setCurrentPermissions(permissionsList);
    }
  }, [permissionsList]);

  useEffect(() => {
    getAdminSettings();
    scrollContainerIntoView(adminSettingsRef);
  }, []);

  useEffect(() => {
    if (roleMode === 'agent') {
      getAgentFeesData();
    }
  }, [roleMode]);

  useEffect(() => {
    if (agentData?.length > 0) {
      const agentPanther = agentData?.filter(item => item?.agent === 'panther');
      setAgentFees(agentPanther[0]);
    }
  }, [agentData]);

  useEffect(() => {
    form.resetFields();
  }, [adminSettingsData]);

  useEffect(() => {
    if (roleMode === 'role') {
      getRolesList();
    }
  }, [roleMode]);

  const updateUser = (userId, roleId) => {
    updateAdminUser(userId, { accessRole: roleId });
  }

  const changeRoleMode = (value) => {
    setRoleMode(value);
    if (!value) {
      setEditMode(false);
    }
  }

  const handleClick = (role) => {
    localStorage.setItem('role', role);
    setTimeout(() => window.location.href = "/admin/users", 50);
  };

  let fees;

  useEffect(() => {
    if (roleMode === 'fee') {
      setInitialData({
        paySystemFee: adminSettingsData?.paySystemFee,
        systemFeePercent: adminSettingsData?.systemFeePercent,
        systemFeePercentReplenish: adminSettingsData?.systemFeePercentReplenish,
        systemFeePercentClient: adminSettingsData?.systemFeePercentClient,
        systemFeePercentSwap: adminSettingsData?.systemFeePercentSwap,
        refundLimitUsd: adminSettingsData?.refundLimitUsd,
        minimumWithdrawalUsd: adminSettingsData?.minimumWithdrawalUsd
      })
    } else if (roleMode === 'agent') {
      setInitialData({
        systemFeePercent: agentFees?.systemFeePercent,
        systemFeePercentReplenish: agentFees?.systemFeePercentReplenish,
        systemFeePercentClient: agentFees?.systemFeePercentClient,
        systemFeePercentSwap: agentFees?.systemFeePercentSwap,
        refundLimitUsd: agentFees?.refundLimitUsd,
        minimumWithdrawalUsd: agentFees?.minimumWithdrawalUsd
      })
    }
  }, [roleMode, adminSettingsData, agentFees]);

  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      form.setFieldsValue(initialData);
    }
  }, [initialData, form]);

  const handleAgentFeesSubmit = (formData) => {
    const agentId = agentFees?.id;

    if (!agentId) {
      console.error("Agent ID not found");
      return;
    }

    updateAgentFeesData(formData, agentId);
  };

  return (
    <div className="admin-settings" ref={adminSettingsRef}>
      <Card>
        <SettingsToggler
          firstMode={t('admin.system_fee_settings')}
          secondMode={t('admin.role_management')}
          thirdMode={t('admin.agent_management')}
          roleMode={roleMode}
          setRoleMode={changeRoleMode}
        />
        {(roleMode === 'fee' || roleMode === 'agent') && !editMode && (
          <Form
            form={form}
            name="admin-settings-form"
            initialValues={initialData}
            onFinish={roleMode === 'fee' ? updateAdminSettings : (formData) => handleAgentFeesSubmit(formData)}
          >
            {roleMode === 'fee' && (
              <Switcher
                name="paySystemFee"
                title={t('admin.system_fee_switcher')}
                description={t('admin.turn_on_switcher')}
              />
            )}
            <SystemFeeSetting name="systemFeePercent" />
            <SystemFeeClientsReplenishment name="systemFeePercentClient" />
            <SystemFeeReplenishmentSetting name="systemFeePercentReplenish" />
            <SystemFeeSwap name='systemFeePercentSwap' />
            <SystemRefund name='refundLimitUsd' />
            <WithdrawalSetting name="minimumWithdrawalUsd" />
          </Form>
        )}
        {roleMode === 'role' && !editMode && (
          <div className="admin-settings__role">
            <div className="admin-settings__role--header">
              <div className={`admin-settings__role--title admin-settings__role--title-${identity}`}>{t('admin.add_role')}</div>
              <div className="admin-settings__role--buttons">
                <Button
                  className="admin-settings__role--add"
                  type="primary"
                  onClick={() => setIsOpenAddUser(true)}
                  disabled={(permissions && permissions?.length > 0 && !permissions[2]?.edit) || !permissions[1]?.view}
                >
                  {t('admin.add_user')}
                </Button>
                <Button
                  className="admin-settings__role--add"
                  type="primary"
                  onClick={() => setIsOpenAddRole(true)}
                  disabled={permissions && permissions?.length > 0 && !permissions[2]?.edit}
                >
                  {t('admin.add_role')}
                </Button>
              </div>
            </div>
            {rolesList && (
              <div>
                {rolesList?.map((item, index) => (
                  <div>
                    <div className={`admin-settings__role--card admin-settings__role--card-${identity} ${(identity === 'inex' || identity === 'coinera') && 'admin-settings__role--card-icons'}`}>
                      <div
                        className={`admin-settings__role--card-name admin-settings__role--card-name-${identity}`}>{item?.name.charAt(0).toUpperCase() + item?.name.slice(1)}</div>
                      {permissions && permissions?.length > 0 && permissions[2]?.edit && (
                        <div>
                          <LinkIcon onClick={() => handleClick(item?.name)} />
                          {item?.name === "admin" ? (
                            <EditIconAdmin />
                          ) : (
                            <EditIcon onClick={() => editPermissions(item?._id)} />
                          )}
                          {item?.name === "admin" ? (
                            <RemoveIconAdmin />
                          ) : (
                            <RemoveIcon
                              onClick={() => openRemoveModal(item?._id, item?.name.charAt(0).toUpperCase() + item?.name.slice(1))} />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
        {editMode && (
          <div className="admin-settings__role">
            <div className="admin-settings__role--header">
              <div className={`admin-settings__role--title admin-settings__role--title-${identity}`}>{t("admin.permissions")}</div>
            </div>
            <div className={`admin-settings__role--permissions admin-settings__role--permissions-${identity}`}>
              <div className={`admin-settings__role--permissions-header admin-settings__role--permissions-header-${identity}`}>
                <div className="admin-settings__role--permissions-actions">{t("admin.actions")}</div>
                <div className={`admin-settings__role--permissions-options admin-settings__role--permissions-options-${identity}`}>
                  <div>{t("admin.view")}</div>
                  <div>{t("admin.edit")}</div>
                </div>
              </div>
              <div className={`admin-settings__role--permissions-role admin-settings__role--permissions-role-${identity}`}>
                {roleName}
              </div>
              <div className={`admin-settings__role--permissions-checkbox admin-settings__role--permissions-checkbox-${identity}`}>
                {currentPermissions?.map((item) => (
                  <div className="admin-settings__role--permissions-line">
                    <div className={`admin-settings__role--permissions-name admin-settings__role--permissions-name-${identity}`}>{item?.name.charAt(0).toUpperCase() + item?.name.slice(1)}</div>
                    <div>
                      <Checkbox
                        onChange={() => handleCheckboxChange(item?.name, 'view')}
                        checked={item?.view}
                      />
                      <Checkbox
                        onChange={() => handleCheckboxChange(item?.name, 'edit')}
                        checked={item?.edit}
                        className="admin-settings__role--permissions-check"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </Card>
      {(roleMode === 'fee' || roleMode === 'agent' || (roleMode === 'role' && editMode)) && (
        <div className="admin-settings-buttons">
          <ButtonSecondary onClick={goBack}>
            {t('admin.cancel')}
          </ButtonSecondary>
          <ButtonPrimary
            type="submit"
            onClick={roleMode === 'fee' || roleMode === 'agent' ? form.submit : handleSubmit}
            disabled={adminSettingsFetching || (permissions && permissions?.length > 0 && !permissions[2]?.edit)}
            loading={adminSettingsFetching}
          >
            {t('admin.save')}
          </ButtonPrimary>
        </div>
      )}
      <AddRoleModal
        getRolesList={getRolesList}
        createNewRole={createNewRole}
        visible={isOpenAddRole}
        close={() => setIsOpenAddRole(false)}
      />
      <AddUserModal
        visible={isOpenAddUser}
        permissions={permissions}
        close={() => setIsOpenAddUser(false)}
        getAdminUsers={getAdminUsers}
        usersList={usersList}
        usersCurrentPage={usersCurrentPage}
        usersPages={usersPages}
        rolesList={rolesList}
        updateAdminUser={updateUser}
      />
      <RemoveRoleModal
        getRolesList={getRolesList}
        visible={isOpenRemoveRole}
        deleteRole={deleteRole}
        close={closeRemoveModal}
        removeId={removeId}
        removeName={removeName}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  usersList: state.adminUsers.entities,
  adminSettingsData: state.adminSettings.data,
  adminSettingsFetching: state.adminSettings.fetching,
  rolesList: state.adminSettings.rolesList,
  permissionsList: state.adminSettings.permissionsList,
  permissions: state.adminSettings.permissions,
  roleName: state.adminSettings.roleName,
  usersCurrentPage: state.adminUsers.page,
  usersPages: state.adminUsers.pages,
  agentData: state.adminSettings.agent,
});

const mapDispatchToProps = {
  getAdminSettings,
  updateAdminSettings,
  getRolesList,
  createNewRole,
  deleteRole,
  getRolePermissions,
  changeRolePermissions,
  getAdminUsers,
  updateAdminUser,
  getAgentFeesData,
  updateAgentFeesData
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
